<template>
  <div class="telzxform">
    <div class="w12">
      <div class="dbyhjs between">
        <div class="flex_start">
          <div class="yhtx">
            <img src="../../assets/claim/aaaa1_sample.png" />
          </div>
          <div>
            <div class="ysmc">王佳佳 <span>律师</span></div>
            <div class="fwpf flex_start">
              <span> 服务评分：</span>
              <el-rate
                v-model="value"
                disabled
                show-score
                disabled-void-color="#9999"
                text-color="#ff9900"
                score-template="{value}"
              >
              </el-rate>
            </div>
          </div>
        </div>
        <div class="ycfzwz">
          付费咨询，诚邀体验，一对一深入解答，问题解决率99%
        </div>
      </div>
      <div class="bdzhengw mt30">
        <div class="bditem flex_start">
          <div class="label">咨询类别：</div>
          <div class="xiangz flex_start">
            <div
              class="dxradio"
              v-for="(item, index) in radios"
              :key="index"
              :class="{ dxradioac: form.type == index }"
              @click="form.type = index"
            >
              {{ item }}
            </div>
          </div>
        </div>

        <div class="bditem flex_start">
          <div class="label">手机号码：</div>
          <div class="xiangz">
            <el-input
              v-model="form.sjh"
              placeholder="请输入您的手机号码"
              style="width: 330px"
            ></el-input>
          </div>
        </div>

        <div class="bditem flex_start">
          <div class="label">验 证 码：</div>
          <div class="xiangz flex_start">
            <el-input
              v-model="form.sjh"
              placeholder="请输入验证码"
              style="width: 200px"
            ></el-input>
            <div class="fsyzm">发送验证码</div>
          </div>
        </div>

        <div class="bditem flex_start">
          <div class="label">服务费用：</div>
          <div class="xiangz">
            <div class="fwfy"><span>¥99</span>/20分钟</div>
          </div>
        </div>

        <div class="bditem flex_start">
          <div class="label">服务费用：</div>
          <div class="xiangz flex_start">
            <div class="paywayradio" :class="{ radact: payway == 'zfb' }">
              <el-radio v-model="payway" label="zfb">
                <img src="~assets/\telzx/iconzfb.png" />
                支付宝
              </el-radio>
            </div>
            <div class="paywayradio" :class="{ radact: payway == 'wx' }">
              <el-radio v-model="payway" label="wx">
                <img src="~assets/\telzx/iconwx.png" />
                微信
              </el-radio>
            </div>
          </div>
        </div>

        <div class="bditem flex_start">
          <div class="label"></div>
          <div class="xiangz">
            <div class="ljzf">立即支付</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data: () => ({
    value: 3.7,
    radios: ["婚姻家庭", "债权债务", "合同纠纷", "刑事辩护"],
    payway: "zfb",
    form: {
      type: 0,
    },
  }),
};
</script>

<style lang="scss" scoped>
.telzxform {
  background-color: #f9f9fa;
  .w12 {
    width: 1200px;
    margin: 0 auto;
    padding: 50px 0;
    .dbyhjs {
      width: 100%;
      padding: 40px 60px;
      background: #edf5ff;
	  background: url(../../assets/question/bg007.png);
      .yhtx {
        margin-right: 20px;
        img {
          width: 120px;
          height: 120px;
          border-radius: 50%;
        }
      }
      .ysmc {
        font-size: 24px;
        color: #000000;
        line-height: 24px;
        span {
          margin-left: 10px;
          font-size: 16px;
          color: #666666;
        }
      }
      .fwpf {
        margin-top: 20px;
        font-size: 16px;
        color: #333333;
      }
      .ycfzwz {
        font-size: 24px;
        color: #333333;
      }
    }
    .bdzhengw {
      width: 100%;
      padding: 30px;
      background-color: #fff;
      .bditem {
        margin-bottom: 30px;
        .label {
          width: 130px;
          font-size: 22px;
          color: #333333;
        }
        .xiangz {
          .dxradio {
            cursor: pointer;
            width: 129px;
            height: 36px;
            text-align: center;
            line-height: 36px;
            border: 1px solid #dbdbdb;
            font-size: 16px;
            color: #666666;
            margin-right: 15px;
            &.dxradioac {
              border: 1px solid #006cff;
              color: #006cff;
            }
          }
          .fsyzm {
            cursor: pointer;
            width: 100px;
            height: 36px;
            line-height: 36px;
            text-align: center;
            background: #0465ea;
            border-radius: 5px;
            font-size: 14px;
            color: #ffffff;
            margin-left: 30px;
          }
          .fwfy {
            font-size: 18px;
            color: #ccc;
            span {
              font-size: 22px;
              color: #ee0404;
            }
          }
          .paywayradio {
            width: 180px;
            height: 60px;
            line-height: 55px;
            text-align: center;
            background: #ffffff;
            border: 1px solid #ececec;
            margin-right: 50px;
            font-size: 18px;
            color: #333333;
            img {
              width: 32px;
              height: 32px;
              margin-right: 8px;
            }
            &.radact {
              border: 1px solid #3083ff;
            }
          }
          .ljzf {
            width: 180px;
            height: 36px;
            text-align: center;
            line-height: 36px;
            background: #0465ea;
            font-size: 14px;
            color: #ffffff;
          }
        }
        &:last-child {
          margin-bottom: 0;
        }

      }
    }
  }
}
</style>